import React from "react"
import Grid from "../../grid"
import Markdown from "../../markdown"

const Location = ({ content, maps_api_key, lat, lng }) => {
  return (
    <Grid gap="32px">
      <Markdown
        componentStyles={{
          h1: { variant: "primary" },
          h2: { variant: "primary" },
          h3: { variant: "primary" },
          p: { variant: "content" },
          li: { variant: "content" },
          a: { variant: "content" }
        }}
      >
        {content}
      </Markdown>

      {lat && lng && (
        <div style={{ height: "400px", width: "100%", borderRadius: "10px", overflow: "hidden" }}>
          <iframe
            src={`https://www.google.com/maps/embed/v1/place?key=${maps_api_key}&q=${lat},${lng}`}
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ border: 0, outline: "none" }}
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </div>
      )}
    </Grid>
  )
}

export default Location
